"use client";

import { cn } from "@workspace/ui";
import { buttonVariants } from "@workspace/ui/components/button";
import { Icons } from "@workspace/ui/components/icons";

import { useAnalytics } from "~/lib/analytics";
import { DISCORD_URL } from "~/lib/constants/urls";

export const DiscordCta = ({
  className,
  source,
}: {
  className?: string;
  source: string;
}) => {
  const { track } = useAnalytics();
  return (
    <a
      className={cn(
        buttonVariants({
          className:
            "h-11 gap-2 bg-[#5865F2] px-7 no-underline hover:bg-[#5865F2]/95",
        }),
        className,
      )}
      href={DISCORD_URL}
      rel="noopener noreferrer"
      target="_blank"
      onClick={() =>
        track("discord_invite", {
          source,
        })
      }
    >
      <Icons.Discord className="size-[1.35rem] text-white" />
      <span className="font-semibold text-white">Join us</span>
    </a>
  );
};
